var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-item" }, [
    _c(
      "a",
      { attrs: { href: _vm.product.url || _vm.url, title: _vm.product.title } },
      [
        _c(
          "div",
          { staticClass: "product-item__image" },
          [
            _vm.product.images.length
              ? _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    "data-src": _vm._f("imageSize")(
                      _vm.product.images[0],
                      "500x"
                    ),
                    alt: _vm.product.title
                  }
                })
              : _vm._t("placeholder-image"),
            _vm._v(" "),
            _vm.isOutOfStock
              ? _c(
                  "span",
                  { staticClass: "product-badge product-badge--best-seller" },
                  [_vm._v(_vm._s(_vm.translations.out_of_stock))]
                )
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "product-item__description" }, [
          _c("span", { staticClass: "product-item__brand" }, [
            _vm._v(_vm._s(_vm.product.vendor))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product-item__name product-name" }, [
            _vm._v(_vm._s(_vm.product.title))
          ]),
          _vm._v(" "),
          _vm.isSale
            ? _c("s", { staticClass: "price price--old" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("currencyFromCents")(_vm.product.compare_at_price)
                  )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "price", class: { "price--sale": _vm.isSale } },
            [_vm._v(_vm._s(_vm._f("currencyFromCents")(_vm.product.price)))]
          ),
          _vm._v(" "),
          _c("div", [
            _vm.isSale
              ? _c("span", { staticClass: "product-item--discount" }, [
                  _vm._v(
                    _vm._s(
                      Math.round(
                        ((_vm.product.compare_at_price - _vm.product.price) /
                          _vm.product.compare_at_price) *
                          100
                      )
                    ) + " % OFF"
                  )
                ])
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.moreColor && _vm.moreColor.length > 0
      ? _c(
          "div",
          { staticClass: "product-item__colors desktop d-none d-md-flex" },
          [
            _c("span", { staticClass: "color--title" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.moreColor.length) +
                  " " +
                  _vm._s(_vm.translations.colour) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "color--selection" },
              _vm._l(_vm.moreColor, function(color) {
                return _c(
                  "a",
                  {
                    key: color.id,
                    attrs: {
                      href: "/products/" + color.split("|")[2],
                      title: _vm._f("titleCase")(color.split("|")[2])
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        class:
                          _vm.product.handle == color.split("|")[2]
                            ? "active"
                            : "",
                        style: { backgroundColor: color.split("|")[1] }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("titleCase")(color.split("|")[2])) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.moreColor && _vm.moreColor.length > 0
      ? _c("div", { staticClass: "product-item__colors mobile d-md-none" }, [
          _c(
            "a",
            {
              staticClass: "color--title",
              attrs: { href: _vm.urlWithinCollection || _vm.url }
            },
            [
              _vm._v(
                "\n            + " +
                  _vm._s(_vm.moreColor.length) +
                  " " +
                  _vm._s(_vm.translations.colour) +
                  "\n        "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }